import { render, staticRenderFns } from "./StoreMessage.vue?vue&type=template&id=3da22cc7&"
import script from "./StoreMessage.vue?vue&type=script&lang=js&"
export * from "./StoreMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports